export default "__VITE_ASSET__8b205fba__"